// extracted by mini-css-extract-plugin
export default {"header":"CommunauteDataIAHeader_header__dM296","image":"CommunauteDataIAHeader_image__eSGyx"};